import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { formatRelativeTime } from '../../../../../../features/post-interactions/utils/interaction.utils';
import { SocialService } from '../../../../../../services/social.service';
import { TripService } from '../../../../../../services/trip.service';
import { WaypointService } from '../../../../../../services/waypoint.service';
import { AuthService } from '../../../../../../core/auth/auth.service';
import { LoaderComponent } from '../../../../reusable/loader/loader.component';
import { Subject, Subscription, forkJoin, of, skip } from 'rxjs';
import {
  WATCH_FEED_FILTER_TABS,
  WatchFeedFilterKey,
  isPlainWaypointPost,
  watchFilterQuery,
} from './watch-feed-filter';
import { ShareImageService } from '../../../../../../services/share-image.service';
import { catchError, takeUntil, timeout } from 'rxjs/operators';
import { SubMenuService } from '../../../../../../services/submenu.service';
import { QueryList, ViewChildren } from '@angular/core';
import { TripsComponent } from '../trips/trips.component';
import { WaypointsComponent } from '../waypoints/waypoints.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ANONYMOUS_ALERT_ALIAS, getWaypointIconAsset, isAlertWaypointType } from '../../../../../../shared/utils/waypoint-icon.util';
import { PostInteractionBarComponent } from '../../../../../../features/post-interactions/components/interaction-bar/post-interaction-bar.component';
import { PostType } from '../../../../../../features/post-interactions/models/post-interactions.models';
import { FleetDetailComponent } from '../fleets/components/fleet-detail/fleet-detail.component';
import { ExitButtonComponent } from '../../../../../../shared/components/buttons/exit-button/exit-button.component';
import { RelativeTimePipe } from '../../../../../../shared/pipes/relative-time.pipe';
import { RideAlongParticipantsComponent } from '../../../../../trip/components/ride-along-participants/ride-along-participants.component';
import { RideAlongService } from '../../../../../../services/ride-along.service';
import { RideAlongParticipant } from '../../../../../trip/models/ride-along.model';
import { UserSettingsService } from '../../../../../../services/user-settings.service';
import { depthFromMeters, distanceFromMeters, speedFromMs, tempFromC } from '../../../../../../shared/utils/unit-formatter.util';
import { TRIP_MAP_PADDING, TRIP_MAP_SIZE, sampleTrackCoords } from '../../../../../../shared/utils/trip-static-map.util';
import { ImageLightboxComponent } from '../../../../../../shared/components/image-lightbox/image-lightbox.component';

@Component({
  selector: 'app-watch',
  standalone: true,
  imports: [CommonModule, ExitButtonComponent, LoaderComponent, TripsComponent, WaypointsComponent, FormsModule, PostInteractionBarComponent, FleetDetailComponent, RelativeTimePipe, RideAlongParticipantsComponent, ImageLightboxComponent],
  templateUrl: './watch.component.html',
  styleUrl: './watch.component.scss',
})
export class WatchComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly watchTripFallbackImage = '/assets/common_icons/vessel_geobg.svg';
  // Match the app's marine basemap style for trip cards.
  private readonly watchTripMapStyleId = '019adf7b-1688-7ff4-ae90-c50ef00338f9';
  @ViewChild('scrollSentinel') scrollSentinel!: ElementRef;
  private observer: IntersectionObserver | null = null;
  feed: any[] = [];
  readonly filterTabs = WATCH_FEED_FILTER_TABS;
  /** Active Watch sub-tab, or null for All. Not persisted: a filter that survives looks like a broken feed. */
  activeFilter: WatchFeedFilterKey | null = null;
  private readonly filterChange$ = new Subject<void>();
  myFleets: any[] = [];
  myDockmates: any[] = [];
  loading = false;
  loadingMore = false;
  loadingSidebar = false;
  currentPage = 1;
  pageSize = 200;
  hasMore = true;
  searchQuery = '';
  seeAllFleets = false;
  seeAllDockmates = false;
  expandedPosts = new Set<string>();
  expandedTripPosts = new Set<string>();
  expandedWps: { [key: string]: boolean } = {};
  loadingDetail:boolean=false

  // Ride-along participants sheet (opened from a ride-along trip post).
  raParticipantsOpen = false;
  raParticipantsTripId = '';
  /** Crew for the open sheet — read from the trip's inline ride_along_participants. */
  raParticipantsList: RideAlongParticipant[] = [];
  /** Trip name shown in the open sheet's subtitle. */
  raParticipantsTripName = '';

  /** True for a ride-along trip post — used to show the "Participants" row. */
  isRideAlongTripPost(post: any): boolean {
    if (post?.post_type !== 'trips') return false;
    const trip = post?.trip_details || post || {};
    if (trip?.ride_along_enabled === true) return true;
    const state = (trip?.trip_state || '').toLowerCase();
    const privacy = (trip?.privacy || '').toLowerCase();
    return (state === 'in_progress' || state === 'paused') && (privacy === 'public' || privacy === 'custom');
  }

  openRideAlongParticipants(post: any, event?: Event): void {
    event?.stopPropagation();
    const trip = post?.trip_details || post || {};
    const tripId = String(trip?._id || trip?.id || post?.trip_id || '').trim();
    // The sheet mirrors the app's "On Board" list: the whole crew (captain first)
    // straight from the trip's inline participants.
    const { captain, participants } = this.rideAlongService.participantsFromTrip(trip);
    this.raParticipantsList = [...(captain ? [captain] : []), ...participants];
    this.raParticipantsTripName = String(trip?.name || post?.name || post?.content?.headline || '').trim();
    if (!tripId && !this.raParticipantsList.length) return;
    this.raParticipantsTripId = tripId;
    this.raParticipantsOpen = true;
  }

  closeRideAlongParticipants(): void {
    this.raParticipantsOpen = false;
  }

  toggleTripPostExpanded(id: string, event: Event) {
    event.stopPropagation();
    if (this.expandedTripPosts.has(id)) {
      this.expandedTripPosts.delete(id);
    } else {
      this.expandedTripPosts.add(id);
    }
  }

  isTripPostExpanded(id: string): boolean {
    return this.expandedTripPosts.has(id);
  }
  activeIndexes: { [key: string]: number } = {};
  @ViewChildren('postCard') postCards!: QueryList<ElementRef>;

  highlightedPostId: string | null = null;
  private targetWaypointIdToFind: string | null = null;
  private subs = new Subscription();
  private seenPostIds = new Set<string>();
  watchTripId: string | null = null;
  watchWaypointId: string | null = null;


  // Send Trip state
  isSendTripOpen = false;
  activeSendTrip: any = null;
  sendTripSearchQuery = '';
  sendFleets: any[] = [];
  sendDockmates: any[] = [];

  // ── Share Image Sheet state ────────────────────────────────────────────────
  isShareImageSheetOpen = false;
  shareImagePost: any = null;
  shareImageStep: 'choose' | 'caption' | 'generating' | 'generated' = 'choose';
  shareImageFile: File | null = null;
  shareImagePreviewUrl: string | null = null;
  shareImageCaption = '';
  shareImageGeneratedFile: File | null = null;
  shareImageGeneratedPreviewUrl: string | null = null;
  shareImagePreparationError = '';
  private shareImagePreparationVersion = 0;

  @Output() openFullProfile = new EventEmitter<{ profileId: string; profileObject: any }>();

  selectedFleet: any = null;

  // Hide-from-me state
  hideConfirmPost: any = null;
  private locallyHiddenWaypointIds = new Set<string>();
  private locallyHiddenTripIds = new Set<string>();
  toastMsg: string | null = null;
  toastColor: 'green' | 'red' = 'green';
  private toastTimer: any = null;

  constructor(
    private socialService: SocialService,
    private tripService: TripService,
    private waypointService: WaypointService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private submenuService: SubMenuService,
    private shareImageService: ShareImageService,
    private location: Location,
    private rideAlongService: RideAlongService,
    private userSettings: UserSettingsService,
  ) { }

  // ── Ride-along participant avatars for a watch trip card ──────────────
  raAvatars: { [tripId: string]: { imageUrl?: string; initials: string }[] } = {};
  private raFetched = new Set<string>();

  /** Two-letter initials (first + last name) — matches the dockmates avatars. */
  raInitials(name: string): string {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  /**
   * Avatars for the Participants row. Reads the trip's inline
   * `ride_along_participants` (the real crew) — riders only, matching the app
   * card which drops the author/captain from the avatar stack. Only falls back
   * to the roster endpoint when the trip carries no inline crew.
   */
  getWatchParticipantAvatars(post: any): { imageUrl?: string; initials: string }[] {
    const trip = post?.trip_details || post || {};
    const { captain, participants } = this.rideAlongService.participantsFromTrip(trip);
    if (captain || participants.length) {
      return participants.map((p) => ({ imageUrl: p.imageUrl, initials: this.raInitials(p.name) }));
    }
    const tripId = String(trip?._id || trip?.id || post?.trip_id || '').trim();
    if (!tripId) return [];
    if (this.raAvatars[tripId]) return this.raAvatars[tripId];
    if (!this.raFetched.has(tripId)) {
      this.raFetched.add(tripId);
      this.rideAlongService.getTripMates(tripId).subscribe({
        next: ({ participants: riders }) => {
          this.raAvatars[tripId] = riders.map((p) => ({ imageUrl: p.imageUrl, initials: this.raInitials(p.name) }));
          this.cdr.markForCheck();
        },
        error: () => { this.raAvatars[tripId] = []; },
      });
    }
    return this.raAvatars[tripId] || [];
  }

  closeFleet(){
    this.selectedFleet = null;
    this.location.replaceState(`/profile`);
  }

  ngOnInit(): void {
    // Reset pagination state on init to handle tab switching
    this.currentPage = 1;
    this.feed = [];
    this.hasMore = true;
    this.loading = false;
    this.loadingMore = false;
    this.seenPostIds.clear();

    // Unit preferences (speed/temp/depth) for the feed cards — shared across
    // screens so a change in Settings lands here too.
    this.userSettings.ensureLoaded();
    this.subs.add(this.userSettings.settings$.pipe(skip(1)).subscribe(() => this.cdr.markForCheck()));

    this.fetchWatchFeed();
    this.fetchSidebarData();

    // Reset immediately when a new account logs in
    this.subs.add(
      this.authService.isLoggedIn$.pipe(skip(1)).subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          this.currentPage = 1;
          this.feed = [];
          this.hasMore = true;
          this.loading = false;
          this.loadingMore = false;
          this.seenPostIds.clear();
          this.fetchWatchFeed();
          this.fetchSidebarData();
        }
      })
    );

    this.subs.add(
      this.submenuService.watchPostNavigation$.subscribe((wpId: string | null) => {
        console.log('[WATCH] received watchPostNavigation$:', wpId, 'loading:', this.loading);
        if (!wpId) return;
        // Clear BehaviorSubject so it doesn't replay on next Watch mount
        this.submenuService.navigateToWatchPost(null);
        // Always use polling-based scroll (handles both loading and loaded states)
        this.scrollToWatchPost(wpId);
      })
    );

    this.subs.add(
      this.submenuService.watchTripNavigation$.subscribe((tripId: string | null) => {
        if (!tripId) return;
        // Clear so it doesn't replay on next Watch mount
        this.submenuService.navigateToWatchTrip(null);
        this.watchTripId = tripId;
      })
    );

    this.subs.add(
      this.submenuService.watchWaypointNavigation$.subscribe((waypointId: string | null) => {
        if (!waypointId) return;
        // Clear so it doesn't replay on next Watch mount
        this.submenuService.navigateToWatchWaypoint(null);
        this.watchWaypointId = waypointId;
      })
    );

    // When the map hides a waypoint/trip, mirror it into the watch feed immediately
    this.subs.add(
      this.submenuService.watchItemHidden$.subscribe(({ tripId, waypointId }) => {
        let changed = false;
        if (waypointId && !this.locallyHiddenWaypointIds.has(waypointId)) {
          this.locallyHiddenWaypointIds.add(waypointId);
          changed = true;
        }
        if (tripId && !this.locallyHiddenTripIds.has(tripId)) {
          this.locallyHiddenTripIds.add(tripId);
          changed = true;
        }
        if (changed) this.cdr.detectChanges();
      })
    );

  }

  ngAfterViewInit(): void {
    // Use a slight delay to ensure the DOM is fully rendered
    setTimeout(() => {
      this.setupObserver();
    }, 50);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.subs.unsubscribe();
    if (this.toastTimer) clearTimeout(this.toastTimer);
    
    // Clean up state on destroy to prevent issues when switching tabs
    this.loading = false;
    this.loadingMore = false;
    this.hasMore = true;
    this.currentPage = 1;
  }

  // ── Hide-from-me helpers ─────────────────────────────────────────────────

  canHidePost(post: any): boolean {
    if (post.post_type !== 'waypoint' && post.post_type !== 'trips') return false;
    return !this.canEditWatchPost(post);
  }

  private getPostWaypointId(post: any): string | undefined {
    const id = String(
      post?.waypoint_details?.waypoint_id ||
      post?.waypoint_details?._id ||
      post?.waypoint_details?.id ||
      post?.waypoint_ref?.identifier ||
      post?.waypoint_ref?.reference_id ||
      ''
    ).trim();
    return id || undefined;
  }

  private getPostTripId(post: any): string | undefined {
    const id = String(
      post?.trip_details?._id ||
      post?.trip_details?.id ||
      post?.trip_details?.trip_id ||
      post?.trip_ref?.identifier ||
      post?.trip_ref?.reference_id ||
      post?.content?.trip_id ||
      ''
    ).trim();
    return id || undefined;
  }

  isPostLocallyHidden(post: any): boolean {
    const wpId = this.getPostWaypointId(post);
    if (wpId && this.locallyHiddenWaypointIds.has(wpId)) return true;
    const tripId = this.getPostTripId(post);
    if (tripId && this.locallyHiddenTripIds.has(tripId)) return true;
    return false;
  }

  onHideClick(post: any, event: Event): void {
    event.stopPropagation();
    this.hideConfirmPost = post;
  }

  cancelHide(): void {
    this.hideConfirmPost = null;
  }

  confirmHide(): void {
    const post = this.hideConfirmPost;
    if (!post) return;
    this.hideConfirmPost = null;

    const waypointId = this.getPostWaypointId(post);
    const tripId = this.getPostTripId(post);

    // Optimistic removal — keyed on content IDs, works for all waypoint types including wreck
    if (waypointId) this.locallyHiddenWaypointIds.add(waypointId);
    if (tripId) this.locallyHiddenTripIds.add(tripId);
    this.cdr.detectChanges();

    // Signal map to remove immediately
    this.submenuService.notifyWatchItemHidden({ tripId, waypointId });

    if (!tripId && !waypointId) {
      this.showToast('Deleted for you.', 'green');
      return;
    }

    this.waypointService.hideForMe(tripId, waypointId).subscribe({
      next: () => this.showToast('Deleted for you.', 'green'),
      error: () => {
        if (waypointId) this.locallyHiddenWaypointIds.delete(waypointId);
        if (tripId) this.locallyHiddenTripIds.delete(tripId);
        this.showToast('Could not hide this item. Please try again.', 'red');
        this.cdr.detectChanges();
      },
    });
  }

  private showToast(msg: string, color: 'green' | 'red'): void {
    if (this.toastTimer) clearTimeout(this.toastTimer);
    this.toastMsg = msg;
    this.toastColor = color;
    this.cdr.detectChanges();
    this.toastTimer = setTimeout(() => {
      this.toastMsg = null;
      this.cdr.detectChanges();
    }, 3000);
  }

  private setupObserver(): void {
    // Clean up existing observer first
    if (this.observer) {
      this.observer.disconnect();
    }
    
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && this.hasMore && !this.loading && !this.loadingMore) {
          console.log('[Watch] IntersectionObserver: Loading more content immediately');
          this.fetchWatchFeed(true);
        }
      },
      {
        threshold: 0.8, // Trigger earlier when 80% visible
        root: null,
        rootMargin: '200px', // Start loading 200px before sentinel comes into view
      },
    );

    // Set up observer immediately
    if (this.scrollSentinel?.nativeElement) {
      this.observer.observe(this.scrollSentinel.nativeElement);
      console.log('[Watch] IntersectionObserver setup successful immediately');
    } else {
      // Retry setup if sentinel is not ready yet
      setTimeout(() => {
        if (this.scrollSentinel?.nativeElement && this.observer) {
          this.observer.observe(this.scrollSentinel.nativeElement);
          console.log('[Watch] IntersectionObserver setup successful after retry');
        } else {
          console.warn('[Watch] Failed to setup IntersectionObserver - sentinel not found');
        }
      }, 10); // Much shorter timeout
    }
  }
  // Display raw value — API already returns in user's preferred units
  getDisplayValue(val: number | null | undefined, decimals: number = 1): string {
    if (val == null) return 'N/A';
    return Number(val).toFixed(decimals);
  }
  getWaypointHeading(subtype: string): string {
    if (!subtype) return 'Waypoint';
    return (
      subtype.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) +
      ' Caught'
    );
  }

  getTripWaypointCount(tripDetails: any): number {
    const fallback = this.getTripWaypointCountFallback(tripDetails);
    return fallback ?? 0;
  }

  isTripWaypointCountLoading(_tripDetails: any): boolean {
    // The waypoint count now comes directly from the feed's trip_details.metrics
    // (populated by the backend's enrich_trips_bulk), exactly like the Flutter app.
    // There is no longer a per-trip async fetch, so there is no loading state.
    return false;
  }

  private getTripWaypointCountFallback(tripDetails: any): number | null {
    // Ordered priority — server-calculated fields are authoritative.
    if (typeof tripDetails?.metrics?.waypoint_count === 'number' && Number.isFinite(tripDetails.metrics.waypoint_count)) return tripDetails.metrics.waypoint_count;
    if (typeof tripDetails?.waypoint_count === 'number' && Number.isFinite(tripDetails.waypoint_count)) return tripDetails.waypoint_count;
    if (Array.isArray(tripDetails?.waypoint_ids)) return tripDetails.waypoint_ids.length;
    if (Array.isArray(tripDetails?.waypoints)) return tripDetails.waypoints.length;
    return null;
  }

  // NOTE: The watch feed previously hydrated each trip's waypoint count by calling
  // GET /trip/{id}/waypoints/ per feed item. That endpoint is ACL-filtered to the
  // caller's own trips, so it returned 404 for every other user's trip in the feed
  // (and produced an N-request waterfall). The Flutter app never makes that call —
  // it reads the count straight from the feed's trip_details.metrics.waypoint_count
  // (populated by the backend's enrich_trips_bulk). We now do the same via
  // getTripWaypointCountFallback(), so the per-trip hydration has been removed.

  /** Switches the sub-tab (null = All) and reloads the feed from page 1. */
  selectFilter(key: WatchFeedFilterKey | null): void {
    if (this.activeFilter === key) return;
    this.activeFilter = key;
    // Drop any in-flight page so a slow response for the old tab cannot land in the new one.
    this.filterChange$.next();
    this.loading = false;
    this.loadingMore = false;
    this.fetchWatchFeed();
  }

  fetchWatchFeed(loadMore: boolean = false): void {
    console.log(`[Watch] fetchWatchFeed called: loadMore=${loadMore} loading=${this.loading} loadingMore=${this.loadingMore} hasMore=${this.hasMore} currentPage=${this.currentPage}`);
    
    if (loadMore) {
      if (!this.hasMore || this.loading || this.loadingMore) {
        console.log('[Watch] Skipping loadMore request');
        return;
      }
      this.loadingMore = true;
      const nextPage = this.currentPage + 1;
      console.log(`[Watch] Loading page ${nextPage} immediately...`);
      this.cdr.detectChanges();

      this.subs.add(
        this.socialService.getWatch(nextPage, this.pageSize, watchFilterQuery(this.activeFilter)).pipe(takeUntil(this.filterChange$), timeout(30000)).subscribe({
          next: (res: any) => {
            console.log(`[Watch] ✅ SUCCESS: Page ${nextPage} loaded`);
            this.currentPage = nextPage;
            this.appendPage(res);
            this.loadingMore = false;
            this.cdr.detectChanges();
            // If sentinel is still visible after this page, load the next one
            setTimeout(() => this.checkSentinelAndLoadMore(), 150);
          },
          error: (err) => {
            console.error(`[Watch] ❌ ERROR loading page ${nextPage}:`, err);
            this.loadingMore = false;
            this.hasMore = false;
            this.cdr.detectChanges();
          },
        })
      );
      return;
    }

    if (this.loading) {
      console.log('[Watch] Already loading initial page, skipping');
      return;
    }

    console.log('[Watch] Loading initial page immediately...');
    this.loading = true;
    this.currentPage = 1;
    this.feed = [];
    this.hasMore = true;
    this.seenPostIds.clear();
    this.cdr.detectChanges();

    this.subs.add(
      this.socialService.getWatch(1, this.pageSize, watchFilterQuery(this.activeFilter)).pipe(takeUntil(this.filterChange$), timeout(30000)).subscribe({
        next: (res: any) => {
          console.log('[Watch] ✅ SUCCESS: Initial page loaded');
          this.appendPage(res);
          this.loading = false;
          if (this.targetWaypointIdToFind) {
            this.scrollToWatchPost(this.targetWaypointIdToFind);
          }
          this.cdr.detectChanges();
          // If page 1 doesn't fill the screen, sentinel stays visible and
          // IntersectionObserver won't re-fire — trigger the next page manually
          setTimeout(() => this.checkSentinelAndLoadMore(), 150);
        },
        error: (err) => {
          console.error('[Watch] ❌ ERROR loading initial page:', err);
          this.loading = false;
          this.hasMore = false;
          this.cdr.detectChanges();
        },
      })
    );
  }

  // After each page renders, continue loading if there are more pages.
  // IntersectionObserver handles scroll-driven loading once pages fill the screen;
  // this call handles the initial case where the sentinel stays visible and IO
  // never re-fires (no intersection change after first blocked callback).
  private checkSentinelAndLoadMore(): void {
    console.log('[Watch] checkSentinelAndLoadMore called:', { hasMore: this.hasMore, loading: this.loading, loadingMore: this.loadingMore });
    
    // Prevent infinite recursion with additional checks
    if (!this.hasMore || this.loading || this.loadingMore) return;
    
    // Only continue loading if the sentinel is actually visible
    if (this.scrollSentinel?.nativeElement) {
      const rect = this.scrollSentinel.nativeElement.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
      
      console.log('[Watch] Sentinel visibility check:', { isVisible, rectTop: rect.top, rectBottom: rect.bottom, windowHeight: window.innerHeight });
      
      if (isVisible) {
        console.log('[Watch] Sentinel is visible, triggering load more');
        this.fetchWatchFeed(true);
      }
    }
  }

  private appendPage(res: any): void {
    console.log('[Watch] === appendPage DEBUG START ===');
    console.log('[Watch] Raw API response type:', typeof res);
    console.log('[Watch] Raw API response:', res);
    
    const rawResults: any[] = Array.isArray(res) ? res : (res?.results || []);
    // Photos/Posts arrive as waypoint posts too; keep them off the Waypoints tab.
    const results = this.activeFilter === 'waypoints' ? rawResults.filter(isPlainWaypointPost) : rawResults;

    console.log('[Watch] Response analysis:', {
      isArray: Array.isArray(res),
      hasResults: !!res?.results,
      nextValue: res?.next,
      nextType: typeof res?.next,
      resultsLength: results.length,
      pageSize: this.pageSize,
      currentPage: this.currentPage
    });

    const newResults = results.filter((post: any) => {
      const id = String(post.id || post._id || '').trim();
      if (id && this.seenPostIds.has(id)) return false;
      if (id) this.seenPostIds.add(id);
      return true;
    });

    this.feed = [...this.feed, ...newResults];

    // CORRECTED pagination logic based on backend implementation
    if (Array.isArray(res)) {
      // Direct array response
      this.hasMore = rawResults.length >= this.pageSize;
      console.log('[Watch] Array response - hasMore set to:', this.hasMore);
    } else {
      // Backend returns: { results: [], next: pageNumber | null, ... }
      // If next is a number, there are more pages
      // If next is null, no more pages
      const nextPage = res?.next;
      this.hasMore = (nextPage !== null && nextPage !== undefined);
      console.log('[Watch] Paginated response - next:', nextPage, 'hasMore:', this.hasMore);
    }

    console.log('[Watch] Final pagination state:', {
      currentPage: this.currentPage,
      resultsReceived: results.length,
      newResultsAdded: newResults.length,
      hasMore: this.hasMore,
      totalFeedLength: this.feed.length
    });
    console.log('[Watch] === appendPage DEBUG END ===');
  }

  fetchSidebarData(): void {
    this.loadingSidebar = true;
    this.myFleets = [];
    this.myDockmates = [];

    // Fetch Fleets
    this.socialService.myFleets(1, 3).subscribe({
      next: (res: any) => {
        this.myFleets = res?.results || [];
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error fetching fleets:', err)
    });

    // Fetch Dockmates
    this.socialService.myDockmates(1, 3).subscribe({
      next: (res: any) => {
        const results = res?.results || [];
        this.myDockmates = results.map((item: any) => {
          const user = item.user || {};
          const name = user.name || (user.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : 'Unknown User');
          return {
            ...user,
            id: user._id || user.id,
            name: name,
            mutual_connections_count: item.mutual_connection_count || user.mutual_connection_count || 0,
            mutual_connections_images: item.mutual_connection_images || user.mutual_connection_images || [],
            boat_name: item.vessel_name || user.vessel_name || user.vessel || 'No Vessel'
          };
        });
        this.cdr.detectChanges();
        this.loadingSidebar = false;
      },
      error: (err) => {
        console.error('Error fetching dockmates:', err);
        this.loadingSidebar = false;
      }
    });
  }

  onPostAvatarClick(post: any, event: Event): void {
    event.stopPropagation();
    const profile = post?.source_profile
      || post?.created_by
      || post?.waypoint_details?.source_profile
      || null;
    const profileId =
      profile?._id || profile?.id || profile?.user_id
      || post?.audit_data?.create_user_id
      || null;
    if (!profileId) return;

    const userId = this.authService.getUserIdFromToken();
    if (profileId === userId) return;

    this.openFullProfile.emit({ profileId, profileObject: profile || { _id: profileId } });
}

  onSidebarDockmatecClick(mate: any): void {
    const profileId = mate._id || mate.id;
    if (!profileId) return;
    this.openFullProfile.emit({ profileId, profileObject: mate });
  }

  onSidebarFleetClick(fleet: any): void {
    this.selectedFleet = fleet;
  }

  onSeeAll(type: 'fleets' | 'dockmates') {
    if (type === 'fleets') {
      this.seeAllFleets = true;
      this.socialService.myFleets(1, 100).subscribe({
        next: (res: any) => {
          this.myFleets = res?.results || [];
          this.cdr.detectChanges();
        }
      });
    } else {
      this.seeAllDockmates = true;
      this.socialService.myDockmates(1, 100).subscribe({
        next: (res: any) => {
          const results = res?.results || [];
          this.myDockmates = results.map((item: any) => {
            const user = item.user || {};
            const name = user.name || (user.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : 'Unknown User');
            return {
              ...user,
              id: user._id || user.id,
              name: name,
              mutual_connections_count: item.mutual_connection_count || user.mutual_connection_count || 0,
              mutual_connections_images: item.mutual_connection_images || user.mutual_connection_images || [],
              boat_name: item.vessel_name || user.vessel_name || user.vessel || 'No Vessel'
            };
          });
          this.cdr.detectChanges();
        }
      });
    }
  }

  onSeeLess(type: 'fleets' | 'dockmates') {
    if (type === 'fleets') {
      this.seeAllFleets = false;
    } else {
      this.seeAllDockmates = false;
    }
    this.cdr.detectChanges();
  }

  onSearch(event: any): void {
    const value = event.target.value;
    this.searchQuery = value;
    // Implementation for filtering or re-fetching based on search if needed
    // For now, we'll keep it as a placeholder as per typical feed search behavior
  }

  isVisible(post: any): boolean {
    if (!post || !post.post_type) return false;
    const supportedTypes = ['trips', 'waypoint', 'fleets', 'watch', 'friends', 'post', 'moment', 'photo'];
    if (!supportedTypes.includes(post.post_type) && !this.isTextPost(post) && !this.isPhotoPost(post)) return false;
    if (this.isPostLocallyHidden(post)) return false;
    return true;
  }

  isPhotoPost(post: any): boolean {
    if (!post) return false;
    const type = String(
      post?.post_type ||
      post?.waypoint_details?.waypoint_type ||
      post?.waypoint_details?.type ||
      post?.type ||
      ''
    ).trim().toLowerCase();
    if (type === 'moment' || type === 'photo' || type === 'photos') return true;
    const name = String(
      post?.waypoint_details?.name ||
      post?.name ||
      post?.content?.headline ||
      ''
    ).trim().toLowerCase();
    return name === 'photo';
  }

  getPostCaption(post: any): string {
    const desc = (
      post?.waypoint_details?.description ||
      post?.description ||
      post?.content?.text ||
      post?.notes ||
      ''
    ).trim();
    if (!desc) return '';
    if (/published a new waypoint/i.test(desc) || /published a new/i.test(desc)) {
      return '';
    }
    return desc;
  }

  getPhotoCoordinates(post: any): string {
    const coords = this.getFullCoordinates(post?.waypoint_details?.position || post?.position);
    if (!coords || coords === 'N/A' || coords.trim() === '') {
      return '';
    }
    return coords;
  }

  isTextPost(post: any): boolean {
    if (!post) return false;
    const type = String(
      post?.post_type ||
      post?.waypoint_details?.waypoint_type ||
      post?.waypoint_details?.type ||
      post?.type ||
      ''
    ).trim().toLowerCase();
    if (type === 'post') return true;
    const name = String(
      post?.waypoint_details?.name ||
      post?.name ||
      post?.content?.headline ||
      ''
    ).trim().toLowerCase();
    return name === 'post';
  }

  getPostText(post: any): string {
    const desc = (
      post?.waypoint_details?.description ||
      post?.description ||
      post?.content?.text ||
      post?.notes ||
      ''
    ).trim();
    if (desc) return desc;
    const name = (
      post?.waypoint_details?.name ||
      post?.name ||
      post?.content?.headline ||
      ''
    ).trim();
    if (name && name.toLowerCase() !== 'post') {
      return name;
    }
    return '';
  }

  getPostImages(post: any): string[] {
    const urls: string[] = [];
    const candidates = [
      post?.image_urls,
      post?.images,
      post?.waypoint_details?.image_urls,
      post?.waypoint_details?.images,
      post?.waypoint_details?.details?.image_urls,
      post?.waypoint_details?.details?.images,
      post?.content?.image_urls,
      post?.content?.images,
    ];

    for (const item of candidates) {
      if (Array.isArray(item)) {
        for (const u of item) {
          const url = typeof u === 'string' ? u : (u?.image_url || u?.imageUrl || u?.url);
          if (typeof url === 'string' && url.trim().length > 0 && !urls.includes(url.trim())) {
            urls.push(url.trim());
          }
        }
      }
    }
    return urls;
  }

  isAlertWaypointPost(post: any): boolean {
    return isAlertWaypointType(post?.waypoint_details || post?.content?.headline || post?.waypoint_ref?.name || post?.waypoint_ref?.type);
  }

  toggleExpand(postId: string): void {
    if (this.expandedPosts.has(postId)) {
      this.expandedPosts.delete(postId);
    } else {
      this.expandedPosts.add(postId);
    }
  }

  isExpanded(postId: string): boolean {
    return this.expandedPosts.has(postId);
  }

  toggleWpExpand(wpId: string): void {
    if (!wpId) return;
    this.expandedWps[wpId] = !this.expandedWps[wpId];
  }

  formatCoordinates(position: any): string {
    if (!position || position.lat === undefined || position.lon === undefined)
      return '';
    const lat = Math.abs(position.lat).toFixed(1);
    const lon = Math.abs(position.lon).toFixed(1);
    const latDir = position.lat >= 0 ? 'N' : 'S';
    const lonDir = position.lon >= 0 ? 'E' : 'W';
    return `${lat}°${latDir} ${lon}°${lonDir}`;
  }

  private scrollToWatchPost(wpId: string): void {
    if (!wpId) return;
    const cleanId = String(wpId).trim();
    console.log('[WATCH] scrollToWatchPost — moving post to top:', cleanId);
    this.targetWaypointIdToFind = cleanId;
    this.movePostToTop(cleanId, 0);
  }

  /**
   * Matches Flutter app behavior: find the post in the feed, move it to
   * position 0 (top of feed), scroll the container to the top, and highlight.
   * If the post hasn't loaded yet, keep fetching more pages until found.
   */
  private movePostToTop(wpId: string, attempt: number): void {
    const cleanId = String(wpId).trim();

    // Try to find the matching post in the current feed
    const matchIndex = this.feed.findIndex((p: any) => {
      const pWpId = p.waypoint_details?.waypoint_id
        || p.waypoint_details?._id
        || p.waypoint_details?.id
        || p.waypoint_ref?.identifier
        || p.id
        || p._id;
      return pWpId && String(pWpId).trim() === cleanId;
    });

    if (matchIndex >= 0) {
      // Found — splice it out and put it at position 0
      const [post] = this.feed.splice(matchIndex, 1);
      this.feed.unshift(post);
      this.targetWaypointIdToFind = null;
      this.highlightedPostId = cleanId;

      // Auto-expand the waypoint stats so the user sees all details
      const postKey = post.id || post._id || post.waypoint_details?.waypoint_id || post.waypoint_details?._id;
      if (postKey) {
        this.expandedWps[postKey] = true;
      }

      this.cdr.detectChanges();

      // Scroll the feed container to the very top
      setTimeout(() => {
        const feedList = document.querySelector('.feed-list');
        if (feedList) {
          const scrollContainer = this.findScrollParent(feedList as HTMLElement);
          if (scrollContainer) {
            scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
      }, 100);

      // Keep highlight for 5 seconds
      setTimeout(() => {
        if (this.highlightedPostId === cleanId) {
          this.highlightedPostId = null;
          this.cdr.detectChanges();
        }
      }, 5000);

      console.log('[WATCH] Post moved to top and highlighted:', cleanId);
    } else {
      // Not found yet — keep loading more pages
      if (attempt > 30) {
        console.warn('[WATCH] movePostToTop timed out after 30 attempts for:', cleanId);
        this.targetWaypointIdToFind = null;
        return;
      }

      if (!this.loading && !this.loadingMore && this.hasMore) {
        console.log('[WATCH] Post not in feed yet, fetching more...');
        this.fetchWatchFeed(true);
      }

      // Retry after 200ms
      setTimeout(() => this.movePostToTop(cleanId, attempt + 1), 200);
    }
  }

  private findScrollParent(el: HTMLElement): HTMLElement | null {
    let parent = el.parentElement;
    while (parent) {
      const overflow = window.getComputedStyle(parent).overflowY;
      if (overflow === 'auto' || overflow === 'scroll') {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  private executeScrollAndHighlight(wpId: string | null, element?: HTMLElement): void {
    if (!wpId) return;
    console.log('[WATCH] executeScrollAndHighlight:', wpId, !!element);
    this.targetWaypointIdToFind = null;
    this.movePostToTop(wpId, 0);
  }

  getWaypointIcon(name: any): string {
    return getWaypointIconAsset(this.getWaypointIconInput(name), 'map');
  }

  // Round icon for the card header circle.
  getWaypointModelIcon(name: any): string {
    return getWaypointIconAsset(this.getWaypointIconInput(name), 'card');
  }

  // Pin-shaped marker for the static-map overlay.
  getWaypointPinIcon(name: any): string {
    return getWaypointIconAsset(this.getWaypointIconInput(name), 'map');
  }

  private getWaypointIconInput(input: any): any {
    if (input?.waypoint_details || input?.waypoint_ref) {
      const details = input?.waypoint_details || {};
      const ref = input?.waypoint_ref || {};
      return {
        ...details,
        type: details.type || details.waypoint_type || details.event_type || details.place_type || ref.type || ref.waypoint_type || ref.event_type || ref.place_type,
        name: details.name || details.waypoint_name || ref.name || ref.title,
        waypoint_name: details.waypoint_name || details.name || ref.name || ref.title,
        fish_subtype: details.fish_subtype || ref.fish_subtype,
        details: {
          ...ref.details,
          ...details.details,
          fish_subtype: details.details?.fish_subtype || details.fish_subtype || ref.details?.fish_subtype || ref.fish_subtype,
        },
      };
    }

    return input;
  }

  getWaypointIconBg(name: string): string {
    const n = (name || '').toLowerCase().replace(/[\s-]/g, '_');
    if (n.includes('fish_mark')) return '#06B6D4';
    if (n.includes('bait_mark')) return '#34C759';
    if (n.includes('temp_break')) return '#FF9F0A';
    if (n.includes('inlet')) return '#007AFF';
    if (n.includes('wreck')) return '#A0522D';
    if (n.includes('canyon')) return '#1C3D5A';
    if (n.includes('anchorage') || n.includes('anchor')) return '#06B6D4';
    if (n.includes('hazard')) return '#FF3B30';
    if (n.includes('home')) return '#007AFF';
    if (n.includes('diver')) return '#00C7BE';
    if (n.includes('patrol')) return '#007AFF';
    if (n.includes('fog')) return '#8E8E93';
    if (n.includes('mob')) return '#FF3B30';
    return '#FF9F0A';
  }

  getInitials(name: string): string {
    if (!name) return '??';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }

  onImageError(event: any) {
    const target = event?.target as HTMLImageElement | undefined;
    if (!target) return;

    // Route broken map/media thumbnails to the requested vessel fallback image,
    // while avatar-like images keep the generic profile fallback.
    const fallback = target.classList?.contains('static-map')
      ? this.watchTripFallbackImage
      : 'assets/trip/watch_defaultlogo.svg';

    if (target.src?.includes(fallback)) return;
    target.src = fallback;
  }

  calculateDuration(
    start: string,
    end: string,
    tripState?: string,
    rawDurationHours?: number
  ): string {
    const toUtcMs = (ts: string): number =>
      new Date(ts.endsWith('Z') ? ts : ts + 'Z').getTime();

    const formatHM = (totalMinutes: number): string => {
      if (totalMinutes <= 0) return '0m';
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;
      return h > 0 ? `${h}h ${m}m` : `${m}m`;
    };

    const state = (tripState || '').trim().toLowerCase();
    const isInProgress =
      state === 'in_progress' || state === 'paused' || state === 'stop_proposed';

    // Priority 1: in-progress → elapsed from start to now
    if (isInProgress && start) {
      const elapsedMs = Date.now() - toUtcMs(start);
      const mins = Math.floor(elapsedMs / 60000);
      return mins > 0 ? formatHM(mins) : '< 1m';
    }

    // Priority 2: completed → start to end wall-clock diff
    if (start && end) {
      const diffMs = toUtcMs(end) - toUtcMs(start);
      const mins = Math.floor(diffMs / 60000);
      if (mins > 0) return formatHM(mins);
    }

    // Priority 3: fallback to backend duration_hours metric
    if (rawDurationHours != null && rawDurationHours > 0) {
      const totalMinutes = Math.round(rawDurationHours * 60);
      return formatHM(totalMinutes);
    }

    return '0m';
  }

  formatExactTime(timestamp: string): string {
    if (!timestamp) return '';
    return formatRelativeTime(timestamp);
  }

  formatDateRange(start: string): string {
    if (!start) return '--';

    const startDate = new Date(start);
    return `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear().toString().slice(-2)}`;
  }
  getDistance(dist: any): string {
    if (dist === undefined || dist === null || isNaN(Number(dist))) return '0 m';
    // API sends nautical miles; distanceFromMeters mirrors the app's rendering,
    // including the sub-0.1-unit fallback to raw metres.
    return distanceFromMeters(Number(dist) * 1852, this.userSettings.distanceUnit, 1, '0 m').text;
  }

  getSogKnots(sog: any): string {
    // API returns SOG in knots — render it in the viewer's speed unit.
    return this.fmtSpeedKnots(sog);
  }

  getStaticMapUrl(wp: any): string {
    const pos = wp?.position;
    if (!pos) return '';
    let lat: number | undefined, lng: number | undefined;

    if (pos.lat !== undefined && pos.lon !== undefined) {
      lat = Number(pos.lat);
      lng = Number(pos.lon);
    } else if (pos.latitude !== undefined && pos.longitude !== undefined) {
      lat = Number(pos.latitude);
      lng = Number(pos.longitude);
    } else if (Array.isArray(pos.coordinates) && pos.coordinates.length >= 2) {
      lng = Number(pos.coordinates[0]);
      lat = Number(pos.coordinates[1]);
    }

    if (lat === undefined || lng === undefined || isNaN(lat) || isNaN(lng)) {
      return '';
    }

    const zoom = 12;
    const width = 400;
    const height = 200;
    const key = 'IfvuVnjKOAzdw0Wrs5eg';
    const mapId = '019adf7b-1688-7ff4-ae90-c50ef00338f9';

    return `https://api.maptiler.com/maps/${mapId}/static/${lng},${lat},${zoom}/${width}x${height}.png?key=${key}`;
  }

  getTripMapUrl(post: any): string {
    const trip = post?.trip_details || post?.tripData || {};
    const key = 'IfvuVnjKOAzdw0Wrs5eg';
    const mapId = this.watchTripMapStyleId;
    const { width, height } = TRIP_MAP_SIZE;

    // Collect all track coordinates from common GeoJSON shapes, then thin them
    // to fit the URL limit WITHOUT losing either end of the voyage.
    const trackData = trip?.track_simplified || trip?.track || trip?.route || trip?.path || post?.content?.track;
    const coords = sampleTrackCoords(this.extractTrackCoords(trackData));

    if (coords.length >= 2) {
      const pathStr = `fill:none|stroke:blue|width:4|${coords.join('|')}`;
      return `https://api.maptiler.com/maps/${mapId}/static/auto/${width}x${height}.png?key=${key}&path=${encodeURIComponent(pathStr)}&padding=${TRIP_MAP_PADDING}`;
    }

    // Fallback to trip position when no trackline is available.
    const startPos =
      this.extractPosDetails(trip?.start_position) ||
      this.extractPosDetails(trip?.startPosition) ||
      this.extractPosDetails(trip?.start);
    const endPos =
      this.extractPosDetails(trip?.end_position) ||
      this.extractPosDetails(trip?.endPosition) ||
      this.extractPosDetails(trip?.end);

    const singleTrackPos =
      coords.length === 1 ? this.extractPosDetails({ coordinates: coords[0].split(',') }) : null;
    const pos =
      singleTrackPos ||
      this.extractPosDetails(trip?.position) ||
      this.extractPosDetails(post?.position) ||
      this.extractPosDetails(post?.content?.position) ||
      startPos ||
      endPos ||
      null;
    if (pos) {
      return this.getTripPositionMapUrl(pos, mapId, width, height, key);
    }

    return this.watchTripFallbackImage;
  }

  private getTripPositionMapUrl(
    pos: { lat: number; lng: number },
    mapId: string,
    width: number,
    height: number,
    key: string
  ): string {
    // No marker overlay: render a clean static map centered on trip position.
    return `https://api.maptiler.com/maps/${mapId}/static/${pos.lng},${pos.lat},13/${width}x${height}.png?key=${key}`;
  }

  private extractTrackCoords(trackData: any): string[] {
    if (!trackData) return [];
    const coords: string[] = [];

    const pushCoord = (coord: any) => {
      if (!Array.isArray(coord) || coord.length < 2) return;
      const lng = Number(coord[0]);
      const lat = Number(coord[1]);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      coords.push(`${lng},${lat}`);
    };

    const pushGeometry = (geom: any) => {
      if (!geom?.type) return;
      if (geom.type === 'Point') {
        pushCoord(geom.coordinates);
        return;
      }
      if (geom.type === 'MultiPoint' && Array.isArray(geom.coordinates)) {
        geom.coordinates.forEach((c: any) => pushCoord(c));
        return;
      }
      if (geom.type === 'LineString' && Array.isArray(geom.coordinates)) {
        geom.coordinates.forEach((c: any) => pushCoord(c));
        return;
      }
      if (geom.type === 'MultiLineString' && Array.isArray(geom.coordinates)) {
        geom.coordinates.forEach((line: any) => Array.isArray(line) && line.forEach((c: any) => pushCoord(c)));
      }
    };

    if (trackData.type === 'FeatureCollection' && Array.isArray(trackData.features)) {
      trackData.features.forEach((f: any) => pushGeometry(f?.geometry));
    } else if (trackData.type === 'Feature') {
      pushGeometry(trackData.geometry);
    } else {
      pushGeometry(trackData);
    }

    return coords;
  }

  private extractPosDetails(pos: any): { lat: number; lng: number } | null {
    if (!pos) return null;
    if (pos.position) return this.extractPosDetails(pos.position);

    const fromLatLng = (
      latVal: any,
      lngVal: any
    ): { lat: number; lng: number } | null => {
      const lat = Number(latVal);
      const lng = Number(lngVal);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    };

    const latLngFormats: Array<[any, any]> = [
      [pos.latitude, pos.longitude],
      [pos.lat, pos.lon],
      [pos.lat, pos.lng],
      [pos.latitude, pos.lng],
    ];

    for (const [latVal, lngVal] of latLngFormats) {
      if (latVal !== undefined && lngVal !== undefined) {
        const parsed = fromLatLng(latVal, lngVal);
        if (parsed) return parsed;
      }
    }

    if (Array.isArray(pos.coordinates) && pos.coordinates.length >= 2) {
      const parsed = fromLatLng(pos.coordinates[1], pos.coordinates[0]);
      if (parsed) return parsed;
    }

    return null;
  }

  formatCoordinate(val: number, type: 'lat' | 'lng'): string {
    if (val === undefined || val === null || isNaN(val)) return '--';
    const absVal = Math.abs(val);
    const degrees = Math.floor(absVal);
    const minutes = ((absVal - degrees) * 60).toFixed(1);
    const direction =
      type === 'lat' ? (val >= 0 ? 'N' : 'S') : val >= 0 ? 'E' : 'W';
    return `${degrees}° ${minutes}' ${direction}`;
  }

  getFullCoordinates(pos: any): string {
    if (!pos) return 'N/A';
    let lat: number | undefined, lng: number | undefined;

    if (pos.lat !== undefined && pos.lon !== undefined) {
      lat = pos.lat;
      lng = pos.lon;
    } else if (pos.latitude !== undefined && pos.longitude !== undefined) {
      lat = pos.latitude;
      lng = pos.longitude;
    } else if (Array.isArray(pos.coordinates) && pos.coordinates.length >= 2) {
      lng = pos.coordinates[0];
      lat = pos.coordinates[1];
    }

    if (lat === undefined || lng === undefined) return 'N/A';
    return `${this.formatCoordinate(lat, 'lat')} ${this.formatCoordinate(lng, 'lng')}`;
  }

  getBadgeType(post: any): 'shared' | 'custom' | 'private' | 'public' {
    if (post.action_type === 'shared') return 'shared';
    const privacy = this.getPrivacy(post);
    if (privacy === 'custom') return 'custom';
    if (privacy === 'private') return 'private';
    return 'public';
  }

  viewGroup(post: any) {
    const community = post?.community_ref || post?.source_community;
    const id = community?._id || community?.id || community?.identifier;
    if (!id) return;
    this.loadingDetail = true
    this.selectedFleet = community;
    this.location.replaceState(`/profile/fleets/${id}`);

    this.socialService.getCommunityById(id).subscribe({
      next: (res: any) => {
        const fetched = res.data || res;
       this.loadingDetail = false
        this.selectedFleet = {
          ...fetched,
          request_status: fetched.request_status || community?.request_status || 'accepted',
          my_role: fetched.my_role || community?.my_role || 'member',
        };
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loadingDetail = false
        console.error('Error fetching fleet:', err);
        this.selectedFleet = { ...community, request_status: community?.request_status || 'accepted', my_role: community?.my_role || 'member' };
        this.cdr.detectChanges();
      }
    });
  }

  getBadgeLabel(post: any): string {
    const type = this.getBadgeType(post);
    if (type === 'shared') return 'Shared';
    if (type === 'custom') return 'Custom';
    if (type === 'private') return 'Private';
    return 'Public';
  }

  getPrivacy(post: any): string {
    if (post.post_type === 'trips') {
      return (post.trip_details?.privacy || 'public').toLowerCase();
    } else if (post.post_type === 'waypoint' || this.isTextPost(post) || this.isPhotoPost(post)) {
      return (post.waypoint_details?.privacy || post.privacy || 'public').toLowerCase();
    }
    return (post.privacy || 'public').toLowerCase();
  }

  onSliderScroll(event: any, wpId: string) {
    const element = event.target;
    const scrollLeft = element.scrollLeft;
    const width = element.offsetWidth;
    const index = Math.round(scrollLeft / width);
    this.activeIndexes[wpId] = index;
  }

  cleanTimeValue(val: string | null | undefined): string {
    if (!val) return '--';
    return val.trim().replace(/\s+DT$/i, '');
  }

  getMoonIllumDisplay(value: any): string {
    if (value == null || value === '') return '--';
    const num = parseFloat(value);
    if (isNaN(num)) return String(value);
    const pct = num > 1 ? Math.round(num) : Math.round(num * 100);
    return `${pct}%`;
  }

  openTripDetails(post: any, forceReadOnly: boolean = false): void {
    const tripId =
      post?.trip_details?._id ||
      post?.trip_details?.id ||
      post?.trip_details?.trip_id ||
      post?.trip_ref?.identifier ||
      post?.trip_ref?.reference_id ||
      post?.content?.trip_id;
    if (!tripId) return;

    // Shared trips or explicit read-only flag open in read-only mode
    if (forceReadOnly || post?.action_type === 'shared') {
      this.submenuService.readOnlyTripMode = true;
    }

    // Pass the available trip data so manage trip can render immediately
    if (post?.trip_details) {
      this.submenuService.pendingTripData = {
        ...post.trip_details,
        _id: tripId,
        source_profile: post.source_profile ?? null,
        reactions: post.reactions ?? post.trip_details?.reactions ?? null,
        comments_count: this.getInteractionCommentsCount(post),
      };
    }

    // Open overlay inline within Watch (do not switch to Trips tab)
    this.watchTripId = tripId;
  }

  // ── Send Trip ─────────────────────────────────────────────────────────────
  private getWatchTripId(post: any): string | null {
    return post?.trip_details?._id || post?.trip_details?.id || post?.trip_details?.trip_id
      || post?.trip_ref?.identifier || post?.trip_ref?.reference_id || post?.content?.trip_id || null;
  }

  openSendTrip(post: any) {
    this.activeSendTrip = post;
    this.sendTripSearchQuery = '';
    this.isSendTripOpen = true;

    const tripId = this.getWatchTripId(post);
    forkJoin([
      this.waypointService.getFleets(),
      this.socialService.myDockmates(1, 100),
      tripId
        ? this.tripService.getTripSharedWith(tripId).pipe(catchError(() => of({ shared_with: { friends: [], fleets: [] } })))
        : of({ shared_with: { friends: [], fleets: [] } }),
    ]).subscribe({
      next: ([fleetsRes, friendsRes, sharedWith]: any[]) => {
        const sw = sharedWith?.shared_with || sharedWith || {};
        const sharedFleetIds: string[] = (sw.fleets || []).map((f: any) => f.community_id).filter(Boolean);
        const sharedFriendIds: string[] = (sw.friends || []).map((f: any) => f.user_id).filter(Boolean);

        this.sendFleets = (fleetsRes.results || []).map((f: any) => ({
          ...f,
          sendSelected: false,
          alreadyShared: sharedFleetIds.includes(f.id) || sharedFleetIds.includes(f._id) || sharedFleetIds.includes(f.community_id),
        }));

        const tokenUserId = this.authService.getUserIdFromToken();
        const objUserId = this.authService.getUserObjectId();
        const results = (friendsRes.results || []).filter((m: any) => {
          return m.user?._id !== objUserId && m.user?.user_id !== tokenUserId;
        });
        this.sendDockmates = results.map((m: any) => ({
          ...m,
          name: m.user?.name || m.name || '',
          image_url: m.user?.image_url || m.image_url || '',
          sendSelected: false,
          alreadyShared: sharedFriendIds.includes(m.user?._id),
        }));
      },
    });
  }

  closeSendTrip() {
    this.isSendTripOpen = false;
    this.activeSendTrip = null;
  }

  confirmSendTrip() {
    if (!this.activeSendTrip) return;
    const tripId = this.getWatchTripId(this.activeSendTrip);
    if (!tripId) return;

    // Only proceed if something NEW was selected
    const newFriendIds = this.sendDockmates.filter((m) => m.sendSelected);
    const newFleetIds = this.sendFleets.filter((f) => f.sendSelected);
    if (newFriendIds.length === 0 && newFleetIds.length === 0) { this.closeSendTrip(); return; }

    // Include already-shared items to preserve them if the API replaces the list
    const friend_ids = this.sendDockmates
      .filter((m) => m.sendSelected || m.alreadyShared)
      .map((m) => m.user?._id)
      .filter(Boolean);
    const fleet_ids = this.sendFleets
      .filter((f) => f.sendSelected || f.alreadyShared)
      .map((f) => f._id);

    this.tripService.shareTrip(tripId, { friend_ids, fleet_ids, message: '' }).subscribe({
      next: (res: any) => {
        console.log('[Watch] Trip sent:', res?.message);
        this.closeSendTrip();
      },
      error: (err: any) => {
        console.error('[Watch] Error sending trip:', err);
        this.closeSendTrip();
      },
    });
  }

  shareTrip(post: any) {
    this.openShareImageSheet(post);
  }

  openShareImageSheet(post: any) {
    this.shareImagePost = post;
    this.shareImageStep = 'choose';
    this.shareImageFile = null;
    if (this.shareImagePreviewUrl) URL.revokeObjectURL(this.shareImagePreviewUrl);
    this.shareImagePreviewUrl = null;
    if (this.shareImageGeneratedPreviewUrl) URL.revokeObjectURL(this.shareImageGeneratedPreviewUrl);
    this.shareImageGeneratedPreviewUrl = null;
    this.shareImageGeneratedFile = null;
    this.shareImageCaption = '';
    this.shareImagePreparationError = '';
    this.shareImagePreparationVersion++;
    this.isShareImageSheetOpen = true;
  }

  closeShareImageSheet() {
    this.isShareImageSheetOpen = false;
    this.shareImagePost = null;
    this.shareImageStep = 'choose';
    this.shareImageFile = null;
    if (this.shareImagePreviewUrl) { URL.revokeObjectURL(this.shareImagePreviewUrl); this.shareImagePreviewUrl = null; }
    if (this.shareImageGeneratedPreviewUrl) { URL.revokeObjectURL(this.shareImageGeneratedPreviewUrl); this.shareImageGeneratedPreviewUrl = null; }
    this.shareImageGeneratedFile = null;
    this.shareImageCaption = '';
    this.shareImagePreparationError = '';
    this.shareImagePreparationVersion++;
  }

  shareImageGoBack() {
    if (this.shareImageStep === 'caption') {
      if (this.shareImagePreviewUrl) URL.revokeObjectURL(this.shareImagePreviewUrl);
      this.shareImageFile = null;
      this.shareImagePreviewUrl = null;
      this.shareImageStep = 'choose';
    } else if (this.shareImageStep === 'generated') {
      this.shareImagePreparationVersion++;
      if (this.shareImageGeneratedPreviewUrl) { URL.revokeObjectURL(this.shareImageGeneratedPreviewUrl); this.shareImageGeneratedPreviewUrl = null; }
      this.shareImageGeneratedFile = null;
      this.shareImagePreparationError = '';
      this.shareImageStep = 'caption';
    } else {
      this.closeShareImageSheet();
    }
  }

  onShareImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    input.value = '';
    this.shareImageFile = file;
    if (this.shareImagePreviewUrl) URL.revokeObjectURL(this.shareImagePreviewUrl);
    this.shareImagePreviewUrl = URL.createObjectURL(file);
    if (this.shareImageGeneratedPreviewUrl) { URL.revokeObjectURL(this.shareImageGeneratedPreviewUrl); this.shareImageGeneratedPreviewUrl = null; }
    this.shareImageGeneratedFile = null;
    this.shareImagePreparationError = '';
    this.shareImageStep = 'caption';
    this.cdr.detectChanges();
  }

  async generateShareCard() {
    if (!this.shareImageFile || this.shareImageStep !== 'caption') return;
    const caption = this.shareImageCaption.trim();
    const file = this.shareImageFile;
    this.shareImagePreparationError = '';
    this.shareImageStep = 'generating';
    this.cdr.detectChanges();
    await new Promise<void>(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
    const version = ++this.shareImagePreparationVersion;
    try {
      const [generatedFile] = await Promise.all([
        this.shareImageService.prepareShareImageForUpload(file, caption),
        new Promise<void>(resolve => setTimeout(resolve, 1500)),
      ]);
      if (version !== this.shareImagePreparationVersion) return;
      if (this.shareImageGeneratedPreviewUrl) URL.revokeObjectURL(this.shareImageGeneratedPreviewUrl);
      this.shareImageGeneratedFile = generatedFile;
      this.shareImageGeneratedPreviewUrl = URL.createObjectURL(generatedFile);
      this.shareImageStep = 'generated';
      this.cdr.detectChanges();
    } catch {
      if (version !== this.shareImagePreparationVersion) return;
      this.shareImageStep = 'caption';
      this.shareImagePreparationError = 'Failed to generate share card';
      this.cdr.detectChanges();
    }
  }

  async confirmShareCard() {
    const file = this.shareImageGeneratedFile;
    if (!file) return;
    const title = this.shareImagePost?.trip_details?.name || this.shareImagePost?.waypoint_details?.name || 'Check out this post!';
    const text = this.shareImageCaption.trim() || undefined;
    const result = await this.shareImageService.shareFile(file, title, text);
    if (result === 'file') { this.closeShareImageSheet(); return; }
    if (result === 'cancelled') return;
    this.showToast('Share card saved!', 'green');
    setTimeout(() => this.closeShareImageSheet(), 1500);
  }

  get filteredSendFleets() {
    if (!this.sendTripSearchQuery) return this.sendFleets;
    return this.sendFleets.filter((f) =>
      f.name?.toLowerCase().includes(this.sendTripSearchQuery.toLowerCase())
    );
  }

  get filteredSendDockmates() {
    if (!this.sendTripSearchQuery) return this.sendDockmates;
    return this.sendDockmates.filter((m) =>
      m.name?.toLowerCase().includes(this.sendTripSearchQuery.toLowerCase())
    );
  }

  // ─────────────────────────────────────────────────────────────────────────

  /**
   * Name of the fleet/community a post was shared WITH (the share target).
   * Mirrors the watch-page detection: use source_community/community_ref only
   * when its name is present and differs from the author's name (a real fleet
   * share), otherwise there is no distinct "shared with" target to show.
   */
  getSharedWithName(post: any): string {
    if (this.isAlertWaypointPost(post)) return '';
    const community = post?.source_community || post?.community_ref;
    const name = (community?.name || '').trim();
    if (!name) return '';
    const author = (post?.source_profile?.name || this.getSharedAuthorName(post) || '').trim();
    if (author && name.toLowerCase() === author.toLowerCase()) return '';
    return name;
  }

  /**
   * Title-case a raw name for display, mirroring the Flutter `_formatDisplayName`:
   * underscores become spaces and each word is capitalised (e.g. `fleet1_capt_love`
   * → `Fleet1 Capt Love`). Used for the shared-with community name and its initials.
   */
  formatDisplayName(name: string | null | undefined): string {
    if (!name) return '';
    return name
      .replace(/_/g, ' ')
      .split(' ')
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
      .join(' ')
      .trim();
  }

  /**
   * A trip/waypoint post that was shared TO a fleet/community. These use the
   * community-style header (fleet avatar + name as primary, author • time as
   * subtitle) to match the Flutter watch feed.
   */
  isSharedCommunityPost(post: any): boolean {
    return (
      (post?.post_type === 'trips' || post?.post_type === 'waypoint') &&
      !!this.getSharedWithName(post)
    );
  }

  /** Image of the fleet/community a post was shared with, if any. */
  getSharedWithImage(post: any): string {
    return post?.community_ref?.image_url || post?.source_community?.image_url || '';
  }

  getSharedAuthorName(post: any): string {
    if (this.isAlertWaypointPost(post)) return ANONYMOUS_ALERT_ALIAS;
    return post?.source_profile?.name
      || post?.author?.name
      || post?.shared_by?.name
      || post?.owner?.name
      || post?.waypoint_details?.user?.name
      || post?.waypoint_details?.owner?.name
      || post?.waypoint_details?.author_name
      || post?.waypoint_details?.shared_by?.name
      || post?.content?.author_name
      || post?.waypoint_ref?.owner_name
      || post?.waypoint_ref?.owner?.name
      || post?.audit_data?.create_user_name
      || post?.waypoint_details?.audit_data?.create_user_name
      || post?.waypoint_details?.created_by?.name
      || '';
  }

  openWaypointDetails(post: any): void {
    const waypointId = post?.waypoint_details?.waypoint_id
      || post?.waypoint_details?._id
      || post?.waypoint_ref?.identifier;
    if (!waypointId) return;
    this.watchWaypointId = waypointId;
  }

  getDescriptionTooltip(desc: string | null | undefined): string {
    if (!desc) return '';
    return desc.trim().split(/\s+/).length > 10 ? desc : '';
  }

  // ── Waypoint card helpers (match Flutter WaypointFeedCard) ──────────────

  getWpName(post: any): string {
    const d = post?.waypoint_details;
    const fishSubtype = d?.details?.fish_subtype;
    if (fishSubtype && (d?.type === 'fish_caught' || (d?.name || '').toLowerCase().includes('fish'))) {
      return this.getWaypointHeading(fishSubtype);
    }
    const type = String(d?.type || '').toLowerCase().replace(/[\s-]/g, '_');
    if (type === 'canyon') return 'Spot';
    if (type === 'inlet') return 'Inlet';
    if (type === 'wreck') return 'Wreck';
    if (type === 'anchorage') return 'Anchorage';
    if (type === 'home') return 'Home';
    if (type === 'hazard') return 'Hazard';
    if (type === 'diver') return 'Diver';
    if (type === 'patrol') return 'Patrol';
    if (type === 'fog') return 'Fog';
    if (type === 'mob') return 'Man Overboard';
    return d?.name || post?.content?.headline || 'Waypoint';
  }

  getWatchHeaderName(post: any): string {
    if (this.isAlertWaypointPost(post)) return ANONYMOUS_ALERT_ALIAS;
    return post?.source_profile?.name || this.getSharedAuthorName(post) || '';
  }

  getFishQuantityBadge(post: any): string | null {
    const d = post?.waypoint_details;
    const qty = d?.details?.fish_quantity;
    if (qty && qty > 1) {
      return `x${qty}`;
    }
    return null;
  }

  getFishQuantityCount(post: any): number | null {
    const qty = Number(post?.waypoint_details?.details?.fish_quantity || 1);
    return qty > 1 ? Math.min(99, qty) : null;
  }

  private getWpObs(wp: any): any {
    return wp?.observation_summary || {};
  }

  getWpConditions(wp: any): string {
    const obs = this.getWpObs(wp);
    const c = (obs.conditions || '').trim();
    const p = (obs.precipitation || '').trim();
    const display = c || p;
    return display || 'None';
  }

  // ── Unit-conversion helpers matching Flutter WaypointFeedCard exactly ──────
  // Flutter rule: water_temp raw = °C (convert), air_temp raw = °F (show as-is),
  // depth raw = meters (convert), sog raw = knots. The RENDERED unit is always
  // the viewer's profile preference (`UnitFormatter.*(value, settings.xUnit)` in
  // watch_tab_view.dart) — these used to be pinned to °F / ft / kts, which is why
  // switching Speed to mph in Settings never showed up on the Watch tab.

  /** The observation's own unit label wins; otherwise the app's raw-value rule. */
  private toCelsius(v: number, unitLabel?: string): number {
    return (unitLabel || '').toLowerCase().trim() === 'fahrenheit' ? (v - 32) * 5 / 9 : v;
  }

  private toMeters(v: number, unitLabel?: string): number {
    return (unitLabel || '').toLowerCase().trim() === 'feet' ? v / 3.28084 : v;
  }

  private fmtWaterTemp(v: number | null | undefined, unitLabel?: string): string {
    if (v == null) return 'N/A';
    return tempFromC(this.toCelsius(Number(v), unitLabel), this.userSettings.temperatureUnit, 1, 'N/A').text;
  }

  private fmtDepth(v: number | null | undefined, unitLabel?: string): string {
    if (v == null) return 'N/A';
    return depthFromMeters(this.toMeters(Number(v), unitLabel), this.userSettings.depthUnit, 1, 'N/A').text;
  }

  private fmtAirTemp(v: number | null | undefined, unitLabel?: string): string {
    if (v == null) return 'N/A';
    // Air temp arrives in °F unless explicitly labelled celsius (app's rule).
    const celsius = (unitLabel || '').toLowerCase().trim() === 'celsius'
      ? Number(v)
      : (Number(v) - 32) * 5 / 9;
    return tempFromC(celsius, this.userSettings.temperatureUnit, 1, 'N/A').text;
  }

  /** SOG arrives in knots from the API; render it in the viewer's speed unit. */
  private fmtSpeedKnots(v: number | null | undefined): string {
    if (v == null || isNaN(Number(v))) return 'N/A';
    return speedFromMs(Number(v) * 0.514444, this.userSettings.speedUnit, 1, 'N/A').text;
  }

  getWpWaterTemp(wp: any): string {
    const obs = this.getWpObs(wp);
    const rawTemp = obs.temp ?? obs.water_temp ?? obs.water_temperature;
    const rawDepth = obs.depth ?? obs.water_depth;
    const tempUnit = obs.water_temperature_unit || obs.temp_unit;
    const depthUnit = obs.depth_unit;
    return `${this.fmtWaterTemp(rawTemp, tempUnit)}`;
  }

  getWpWaterDepth(wp: any): string {
    const obs = this.getWpObs(wp);
    const rawTemp = obs.temp ?? obs.water_temp ?? obs.water_temperature;
    const rawDepth = obs.depth ?? obs.water_depth;
    const tempUnit = obs.water_temperature_unit || obs.temp_unit;
    const depthUnit = obs.depth_unit;
    return `${this.fmtDepth(rawDepth, depthUnit)}`;
  }

  getWpSpeed(wp: any): string {
    return this.fmtSpeedKnots(this.getWpObs(wp).sog);
  }

  getWpHeading(wp: any): string {
    const cog = this.getWpObs(wp).cog;
    return cog != null ? `${Number(cog).toFixed(0)}°` : 'N/A';
  }

  getWpWaveHeightPeriod(wp: any): string {
    const obs = this.getWpObs(wp);
    const wh = obs.wave_height;
    const wp2 = obs.wave_period;
    if (wh == null && wp2 == null) return 'N/A · N/A';
    const whStr = wh != null ? `${Number(wh).toFixed(1)} m` : 'N/A';
    const wpStr = wp2 != null ? `${Number(wp2).toFixed(0)} s` : 'N/A';
    return `${whStr} · ${wpStr}`;
  }

  hasWpBuoyOrWave(wp: any): boolean {
    const obs = this.getWpObs(wp);
    return !!(obs.ndbc_buoy_id || obs.ndbc_timestamp || obs.wave_height != null || obs.wave_period != null);
  }

  getWpBuoyId(wp: any): string {
    return (this.getWpObs(wp).ndbc_buoy_id || '').trim() || 'N/A';
  }

  getWpLastReading(wp: any): string {
    const ts = (this.getWpObs(wp).ndbc_timestamp || '').trim();
    if (!ts) return 'N/A';
    const parsed = new Date(ts);
    if (isNaN(parsed.getTime())) return ts;
    return `${parsed.getMonth() + 1}/${parsed.getDate()}/${parsed.getFullYear().toString().slice(-2)}`;
  }

  /** Trip-summary air temp — the field is °F; render in the viewer's unit. */
  getAirTempF(v: number | null | undefined): string {
    if (v == null || isNaN(Number(v))) return '--';
    return tempFromC((Number(v) - 32) * 5 / 9, this.userSettings.temperatureUnit, 1, '--').text;
  }

  getWpAirTemp(wp: any): string {
    const obs = this.getWpObs(wp);
    return this.fmtAirTemp(obs.air_temperature, obs.air_temperature_unit);
  }

  getWpAirPressure(wp: any): string {
    const v = this.getWpObs(wp).air_pressure;
    if (v == null) return 'N/A';
    return `${Number(v).toFixed(2)} inHg`;
  }

  getWaypointImages(wp: any): string[] {
    if (!wp) return [];
    const urls = wp.image_urls || [];
    const images = wp.images || [];

    // Combine both sources and filter out invalid ones
    const combined = [...urls];
    images.forEach((img: any) => {
      if (img.image_url && !combined.includes(img.image_url)) {
        combined.push(img.image_url);
      }
    });

    return combined
      .filter((u) => u && typeof u === 'string')
      .map((u: string) => u.trim())
      .filter((u: string) => u.length > 0);
  }

  // ── Waypoint media carousel (photos + static map) ────────────────────────────
  // Mirrors the Flutter WaypointMediaCarousel: photo pages first, the static map
  // is the final page. When there are no photos only the map shows (no slider).
  private wpSlidesCache = new Map<string, { type: 'image' | 'map'; url: string }[]>();
  wpSlideIndex: Record<string, number> = {};

  private wpCarouselKey(post: any): string {
    return String(
      post?.id ||
      post?._id ||
      post?.waypoint_details?.waypoint_id ||
      post?.waypoint_details?._id ||
      post?.waypoint_details?.id ||
      ''
    );
  }

  /** Ordered carousel slides: photos first, static map last. Memoised per post. */
  getWpMediaSlides(post: any): { type: 'image' | 'map'; url: string }[] {
    const key = this.wpCarouselKey(post);
    const images = this.getWaypointImages(post?.waypoint_details);
    const mapUrl = this.getStaticMapUrl(post?.waypoint_details);

    const cached = this.wpSlidesCache.get(key);
    if (
      cached &&
      cached.length === images.length + 1 &&
      cached[cached.length - 1].url === mapUrl &&
      images.every((u, i) => cached[i]?.url === u)
    ) {
      return cached;
    }

    const slides: { type: 'image' | 'map'; url: string }[] = images.map((url) => ({
      type: 'image' as const,
      url,
    }));
    slides.push({ type: 'map', url: mapUrl });

    if (key) this.wpSlidesCache.set(key, slides);
    return slides;
  }

  getWpSlideIndex(post: any): number {
    return this.wpSlideIndex[this.wpCarouselKey(post)] || 0;
  }

  // ── Photo lightbox ──────────────────────────────────────────────────────────
  // Feed photos were inert: the map slide navigated to the map, the photo slide
  // did nothing at all, so a picture could only ever be seen at thumbnail size.

  lightboxOpen = false;
  lightboxImages: string[] = [];
  lightboxIndex = 0;

  /** Expand the tapped photo, carrying the post's other photos for paging. */
  openPhotoLightbox(post: any, url: string, event?: Event): void {
    event?.stopPropagation();
    // Photos only — the static map is a slide in the carousel but not an image
    // worth expanding, and including it would offset the index.
    const images = this.getWpMediaSlides(post)
      .filter((s) => s.type === 'image')
      .map((s) => s.url)
      .filter(Boolean);
    if (!images.length) return;
    const idx = images.indexOf(url);
    this.lightboxImages = images;
    this.lightboxIndex = idx >= 0 ? idx : 0;
    this.lightboxOpen = true;
  }

  closePhotoLightbox(): void {
    this.lightboxOpen = false;
    this.lightboxImages = [];
    this.lightboxIndex = 0;
  }

  setWpSlide(post: any, index: number, event?: Event): void {
    event?.stopPropagation();
    this.wpSlideIndex[this.wpCarouselKey(post)] = index;
  }

  wpNextSlide(post: any, total: number, event?: Event): void {
    event?.stopPropagation();
    const key = this.wpCarouselKey(post);
    const current = this.wpSlideIndex[key] || 0;
    this.wpSlideIndex[key] = (current + 1) % total;
  }

  wpPrevSlide(post: any, total: number, event?: Event): void {
    event?.stopPropagation();
    const key = this.wpCarouselKey(post);
    const current = this.wpSlideIndex[key] || 0;
    this.wpSlideIndex[key] = (current - 1 + total) % total;
  }

  trackBySlideIndex(index: number): number {
    return index;
  }

  private getWatchWaypointId(post: any): string | null {
    return String(
      post?.waypoint_details?.waypoint_id ||
      post?.waypoint_details?._id ||
      post?.waypoint_details?.id ||
      post?.waypoint_ref?.identifier ||
      post?.waypoint_ref?.reference_id ||
      post?.waypoint_ref?._id ||
      post?.waypoint_ref?.id ||
      post?.id ||
      post?._id ||
      ''
    ).trim() || null;
  }

  private getWatchWaypointPosition(post: any): any {
    return post?.waypoint_details?.position || post?.waypoint_ref?.position || null;
  }

  private getWatchWaypointCreateTs(post: any): string | null {
    return post?.waypoint_details?.audit_data?.create_ts
      || post?.waypoint_details?.created_at
      || post?.audit_data?.create_ts
      || post?.created_at
      || null;
  }

  private goToWaypointFromWatch(post: any): void {
    const wpId = this.getWatchWaypointId(post);
    if (!wpId) return;

    const createTs = this.getWatchWaypointCreateTs(post);
    const position = this.getWatchWaypointPosition(post);
    const waypointData = post?.waypoint_details || null;

    this.submenuService.setUserProfileOpenState(false);
    this.submenuService.focusOnMap('waypoint', wpId, position, createTs || undefined, undefined, 'watch', waypointData);
  }

  onWpMapClick(post: any, event: Event) {
    event.stopPropagation();
    this.goToWaypointFromWatch(post);
  }

  onTripMapClick(post: any, event: Event) {
    event.stopPropagation();

    const tripId =
      post?.trip_details?._id ||
      post?.trip_details?.id ||
      post?.trip_details?.trip_id ||
      post?.trip_ref?.identifier ||
      post?.trip_ref?.reference_id ||
      post?.content?.trip_id;
    const createTs = post.audit_data?.create_ts || post.created_at;

    if (!tripId) return;

    this.submenuService.setUserProfileOpenState(false);
    if (post?.trip_details) {
      this.submenuService.pendingTripData = {
        ...post.trip_details,
        _id: tripId,
        source_profile: post.source_profile ?? null,
        reactions: post.reactions ?? post.trip_details?.reactions ?? null,
        comments_count: this.getInteractionCommentsCount(post),
      };
    }
    this.submenuService.focusOnMap('trip', tripId, null, createTs, post?.trip_details, 'watch');
  }
  isFleetOwner(post: any): boolean {
    const fleetId = post.community_ref?._id || post.community_ref?.id;
    if (!fleetId) return false;
    const fleet = this.myFleets.find((f: any) => (f._id || f.id) === fleetId);
    return fleet?.my_role === 'owner';
  }

  canEditWatchPost(post: any): boolean {
    const userId = this.authService.getUserObjectId();
    const authId = this.authService.getUserIdFromToken();
    const creatorId = post.audit_data?.create_user_id
      || post.source_profile?._id
      || post.source_profile?.id;
    if (!creatorId) return false;
    return creatorId === userId || creatorId === authId;
  }

  getInteractionPostId(post: any): string {
    if (!post) return '';
    if (post.post_type === 'trips') {
      return this.getWatchTripId(post) || String(post.id || post._id || '');
    }
    if (post.post_type === 'waypoint' || this.isTextPost(post) || this.isPhotoPost(post)) {
      return this.getWatchWaypointId(post) || String(post.id || post._id || '');
    }
    return String(post.id || post._id || '');
  }

  getInteractionPostType(post: any): PostType {
    return post?.post_type === 'trips' ? 'trips' : 'waypoint';
  }

  getInteractionCommentsCount(post: any): number {
    const details = (post?.post_type === 'waypoint' || this.isTextPost(post) || this.isPhotoPost(post)) ? post?.waypoint_details : post?.trip_details;
    const candidates = [
      post?.comments_count,
      post?.comment_count,
      post?.reactions?.comment_count,
      post?.comments?.count,
      post?.comments?.length,
      post?.engagement?.comments_count,
      post?.engagement?.comment_count,
      post?.interactions?.comments_count,
      post?.interactions?.comment_count,
      post?.interaction_counts?.comments,
      post?.interaction_counts?.comment_count,
      details?.comments_count,
      details?.comment_count,
      details?.reactions?.comment_count,
      details?.comments?.count,
      details?.comments?.length,
      details?.engagement?.comments_count,
      details?.engagement?.comment_count,
      details?.interactions?.comments_count,
      details?.interactions?.comment_count,
    ];

    for (const value of candidates) {
      const count = Number(value);
      if (Number.isFinite(count) && count >= 0) {
        return count;
      }
    }

    return 0;
  }

  onInteractionShare(post: any): void {
    this.shareTrip(post);
  }
}
